import type {ReactNode} from 'react'
import {IconButton} from '@primer/react'
import {PlusIcon, GearIcon, ChevronLeftIcon, ChevronDownIcon} from '@primer/octicons-react'
import styles from './SidebarSection.module.css'

type ActionType = 'add' | 'settings' | 'back' | 'expand'

const defaultActions: ActionType[] = ['add', 'settings']

interface SidebarSectionProps {
  title: string
  actions?: ActionType[]
  children?: ReactNode
}

/** Reusable sidebar metadata section (Assignees, Labels, etc.) */
export function SidebarSection({title, actions = defaultActions, children}: SidebarSectionProps) {
  return (
    <section aria-label={title}>
      <div className={styles.header}>
        <h4 className={styles.sectionTitle}>{title}</h4>
        <span className={styles.headerActions}>
          {actions.map(action => (
            <ActionButton key={action} action={action} title={title} />
          ))}
        </span>
      </div>
      <div className={styles.body}>{children ?? <p className={styles.emptyState}>None yet</p>}</div>
    </section>
  )
}

function ActionButton({action, title}: {action: ActionType; title: string}) {
  const iconMap = {
    add: {icon: PlusIcon, label: `Add ${title.toLowerCase()}`},
    settings: {icon: GearIcon, label: `Manage ${title.toLowerCase()}`},
    back: {icon: ChevronLeftIcon, label: `Navigate ${title.toLowerCase()}`},
    expand: {icon: ChevronDownIcon, label: `Expand ${title.toLowerCase()}`},
  }
  const {icon: Icon, label} = iconMap[action]
  return <IconButton icon={Icon} aria-label={label} variant="invisible" size="small" />
}
